import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProviderWrapper } from './contexts/ThemeContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Trees from './pages/Trees';
import TreeDetail from './pages/TreeDetail';
import Flaechen from './pages/Flaechen';
import FlaecheDetail from './pages/FlaecheDetail';
import MapView from './pages/MapView';
import Users from './pages/Users';
import Import from './pages/Import';
import ActivityLog from './pages/ActivityLog';
import Leistungsverzeichnis from './pages/Leistungsverzeichnis';
import Auswertung from './pages/Auswertung';
import ReleaseNotes from './pages/ReleaseNotes';
import MeineAufgaben from './pages/MeineAufgaben';
import AppLayout from './components/AppLayout';


// Protected Route
const ProtectedRoute: React.FC<{ children: React.ReactNode; adminOnly?: boolean }> = ({ children, adminOnly }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" />;
  if (adminOnly && user.role !== 'admin') return <Navigate to="/dashboard" />;
  return <>{children}</>;
};

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return null;

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/dashboard" /> : <Login />} />
      <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/trees" element={<Trees />} />
        <Route path="/trees/:id" element={<TreeDetail />} />
        <Route path="/flaechen" element={<Flaechen />} />
        <Route path="/flaechen/:id" element={<FlaecheDetail />} />
        <Route path="/map" element={<MapView />} />
        <Route path="/meine-aufgaben" element={<MeineAufgaben />} />
        <Route path="/users" element={<ProtectedRoute adminOnly><Users /></ProtectedRoute>} />
        <Route path="/import" element={<ProtectedRoute adminOnly><Import /></ProtectedRoute>} />
        <Route path="/activity" element={<ActivityLog />} />
        <Route path="/leistungsverzeichnis" element={<Leistungsverzeichnis />} />
        <Route path="/auswertung" element={<Auswertung />} />
        <Route path="/release-notes" element={<ReleaseNotes />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProviderWrapper>
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProviderWrapper>
  );
}
